import { useEntitlementContext } from '@/features/auth/EntitlementContext';
import type { FeatureKey, InternalPlan, MarketplaceAccess } from '@/features/auth/types';

export type { FeatureKey };

/** Active Marketplace entitlement, or null outside the protected shell. */
export function useEntitlement(): MarketplaceAccess | null {
  return useEntitlementContext();
}

/**
 * Plan gate — mirrors `useCan()` in permissions.ts. Untagged entries (no key)
 * are always enabled; tagged ones need the key in `enabledFeatures`.
 */
export function useFeatureEnabled() {
  const entitlement = useEntitlementContext();
  return (feature?: FeatureKey): boolean =>
    !feature || Boolean(entitlement?.enabledFeatures.includes(feature));
}

const planLabels: Record<InternalPlan, string> = {
  FOUNDATION: 'Foundation',
  PROFESSIONAL: 'Professional',
  ENTERPRISE: 'Enterprise',
};

export function formatPlan(plan: InternalPlan): string {
  return planLabels[plan];
}
